import { render, staticRenderFns } from "./Avintercom.vue?vue&type=template&id=13071ea4&scoped=true&"
import script from "./Avintercom.vue?vue&type=script&lang=js&"
export * from "./Avintercom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13071ea4",
  null
  
)

export default component.exports